<div class="search-container" attr.data.test="formSearchEmployee" [ngClass]="{'--has-search': hasSearch }" >
  <form [formGroup]="formSearch">
    <input type="text" attr.data.test="InputSearchEmployee" formControlName="search" aria-label="Busque por nome, CPF ou matrícula" (keyup.enter)="initSearch()"  placeholder="Busque por nome, CPF ou matrícula">
    <button type="reset">Excluir Pesquisa</button>
  </form>
</div>
